import styled from '@emotion/styled'
import { useCountry } from 'hooks'
import { useTranslation } from 'react-i18next'
import ReportProblemIcon from '@mui/icons-material/ReportProblem'

const Container = styled('div')`
  padding: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
`
const legacyRoutes = ['appointments', 'settings', 'consultant', 'reservation', 'schedule']

const CountryNotSupported = () => {
  const country = useCountry()
  const { t } = useTranslation()
  const translationKey = legacyRoutes.includes(country.toLowerCase()) ? 'pages.invalidUrl.message' : 'pages.countryNotSupported.message'

  return (
    <Container>
      <ReportProblemIcon /> {t(translationKey, { country })}
    </Container>
  )
}

export { CountryNotSupported }
